import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path } from "react-native-svg";

export default function Dismiss(props) {
  const w = props.width || 16;
  const h = props.height || 16;

  return (
    <TouchableOpacity style={props.styles} {...props}>
      <Svg
        width={w}
        height={h}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M15.3333 2.66667H11.3333V1.66667C11.3333 1.48986 11.3619 0.861919 11 0.5C10.6381 0.138081 9.84348 0 9.66667 0H6.33333C6.15652 0 5.42448 0.0755267 5 0.5C4.57552 0.924473 4.66667 1.48986 4.66667 1.66667V2.66667H0.666667C0.489856 2.66667 0.320286 2.7369 0.195262 2.86193C0.0702379 2.98695 0 3.15652 0 3.33333C0 3.51014 0.0702379 3.67971 0.195262 3.80474C0.320286 3.92976 0.489856 4 0.666667 4H15.3333C15.5101 4 15.6797 3.92976 15.8047 3.80474C15.9298 3.67971 16 3.51014 16 3.33333C16 3.15652 15.9298 2.98695 15.8047 2.86193C15.6797 2.7369 15.5101 2.66667 15.3333 2.66667ZM6 2.33333C6 1.78105 6.44772 1.33333 7 1.33333H9C9.55229 1.33333 10 1.78105 10 2.33333V2.66667H6V2.33333Z"
          fill="#DD5F43"
        />
        <Path
          d="M2 5.33334V14C2 14.5304 2.21071 15.0392 2.58579 15.4142C2.96086 15.7893 3.46957 16 4 16H12C12.5304 16 13.0391 15.7893 13.4142 15.4142C13.7893 15.0392 14 14.5304 14 14V5.33334H2ZM10.9427 12.6567L10 13.6L8 11.6L6 13.6L5.05733 12.6567L7.05733 10.6567L5.05733 8.65668L6 7.71401L8 9.71401L10 7.71401L10.9427 8.65668L8.94267 10.6567L10.9427 12.6567Z"
          fill="#DD5F43"
        />
      </Svg>
    </TouchableOpacity>
  );
}
